import React from 'react';
import { Link } from 'react-router-dom';

export function PictureSgDisclaimer() {

    const triggerForm = () => {
        if (sessionStorage.getItem('afs')) {
            sessionStorage.removeItem('afs');
        }
    }

    return (
        <section id="PictureSgDisclaimer">
            <div className="container-fluid mt-3 disclaimer minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <img src="./images/icn-BLUEpictureSG.png" alt="" />
                                <h2 className="pageTitle mt-2">Images from National Library, Singapore</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-8 offset-md-2">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        <div className="text-center mb-3">
                                            <h3 className="theme-color">Getting Started</h3>
                                        </div>
                                        <div className="theme-color">
                                            <p>
                                                You are about to leave the e-Request page and will be redirected to <a className="fw-bold" href={process.env.REACT_APP_PICTURESG_URL} target="_self" title="National Library Online">National Library Online</a>, where you can search for images.
                                            </p>
                                        </div>
                                        <div className="theme-color text-center">To learn more, click <Link className="fw-bold" to="/picturesg/guide">here</Link>.</div>
                                        <div className="text-center mt-3">
                                            <a onClick={() => triggerForm()} href={process.env.REACT_APP_PICTURESG_URL} target="_self" title="National Library Online" className="btn btn-primary me-2">Proceed</a>
                                            <Link to={'/'} className="btn btn-secondary">Cancel</Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





